import React from "react";
import { Box, useTheme } from "@mui/material";
import LeadHeader from "@/modules/lead-page/new/components/header/lead-header";
import MobileActionCards from "./mobile-action-cards";

interface MobileLeadHeaderProps {
  isLeadArchived: boolean;
  onTasksClick: () => void;
  onNextActionsClick: () => void;
  onRecommendationsClick: () => void;
  onActivitiesClick: () => void;
  onSalesClick: () => void;
  onPropertiesClick: () => void;
  onInterestsClick: () => void;
  onDeveloperTracksClick: () => void;
  onRatingsClick: () => void;
  isRatingsOpen: boolean; // Controls card visibility
  isDeveloperTracksVisible: boolean;
}

const MobileLeadHeader: React.FC<MobileLeadHeaderProps> = ({
  isLeadArchived,
  onTasksClick,
  onNextActionsClick,
  onRecommendationsClick,
  onActivitiesClick,
  onSalesClick,
  onPropertiesClick,
  onInterestsClick,
  onDeveloperTracksClick,
  onRatingsClick,
  isRatingsOpen,
  isDeveloperTracksVisible,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "100vw",
        backgroundColor: theme.nawy.colors.semantic.layer.secondary,
        overflow: "hidden",
        padding: theme.nawy.spacing.sm,
        gap: theme.nawy.spacing.sm,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <LeadHeader />

      <MobileActionCards
        isRatingsOpen={isRatingsOpen}
        onRatingsClick={onRatingsClick}
        onTasksClick={onTasksClick}
        onNextActionsClick={onNextActionsClick}
        onRecommendationsClick={onRecommendationsClick}
        onActivitiesClick={onActivitiesClick}
        onSalesClick={onSalesClick}
        onPropertiesClick={onPropertiesClick}
        onInterestsClick={onInterestsClick}
        onDeveloperTracksClick={onDeveloperTracksClick}
        isLeadArchived={isLeadArchived}
        isDeveloperTracksVisible={isDeveloperTracksVisible}
      />
    </Box>
  );
};

export default MobileLeadHeader;
